import React, { useEffect, useState } from "react";
import { MdDelete } from "react-icons/md";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import PaginatedView from "../../../components/UI/PaginatedView/PaginatedView";
import funcionalidades from "../../../context/AuthContext.funcionalidades";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import ButtonImagePermission from "../../../components/UI/Button/ButtonImagePermission";
import EfisModal from "../../../components/UI/EfisModal/EfisModal";
import DetalhamentoModeloImportacao from "./DetalhamentoModeloImportacao";

const downloadCell = (row, setShowExcluirConfirm) => (
  <>
    <FileDownloader
      binario={row.arquivo}
      tooltip={row.nomeArquivo === null ? "Nenhum modelo encontrado" : `Download do modelo ${row.nomeArquivo}`}
      nomeArquivo={row.nomeArquivo}
      disabled={row.nomeArquivo === null}
    />
    <ButtonImagePermission
      permission={funcionalidades.modeloImportacao.deletar}
      className="btn-lg text-danger pa-0 p-0"
      onClick={() =>
        setShowExcluirConfirm({
          show: true,
          body: `Deseja realmente excluir "${row.descricaoModelo}"?`,
          context: row.sequenceModelo,
        })
      }
      buttonImage={<MdDelete />}
      tooltipImage="Excluir"
    />
  </>
);

const ConsultaModeloImportacao = ({ history, match }) => {
  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showExcluirConfirm, setShowExcluirConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });

  const columns = [
    {
      name: "Nome",
      selector: "descricaoModelo",
      sortable: true,
    },
    {
      name: "Arquivo Modelo",
      selector: "nomeArquivo",
    },
    {
      name: "Ações",
      selector: "",
      maxWidth: "10%",
      center: true,
      cell: (row) => downloadCell(row, setShowExcluirConfirm),
    },
  ];

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData) {
      toast.success("Modelo de Importação excluído com sucesso.");
      document.location.reload(true);
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowExcluirConfirm({ show: false });
  }, [deleteItemData, deleteItemErrors, setShowExcluirConfirm, history]);

  return (
    <>
      <EfisModal
        show={showExcluirConfirm.show}
        body={showExcluirConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowExcluirConfirm({ show: false })}
        confirmationHandler={() => {
          const params = { sequenceModelo: showExcluirConfirm.context };
          deleteItemRequest(apiRoutes.fiscalizacao.parametrizacao.excluiModeloImportacao, params);
        }}
      />

      <PaginatedView
        title="Modelos de Importação"
        keyField="sequenceModelo"
        descriptionField="descricaoModelo"
        defaultSearch
        defaultSearchPlaceholder="Nº Ocorrência"
        queryService={apiRoutes.fiscalizacao.parametrizacao.consultaModeloImportacao}
        editRoute={`${match.url}/form`}
        columns={columns}
        expandComponent={DetalhamentoModeloImportacao}
        permissionInsert={funcionalidades.modeloImportacao.inserir}
        history={history}
      />
    </>
  );
};

export default ConsultaModeloImportacao;
